<section class="dsm-flex-container survey-results-container">
    <div *ngIf="busy" class="flex-row">
        <usana-spinner [show]="busy" [delay]="100"></usana-spinner>
    </div>
    <div class="panel-container" *ngIf="!busy">
        <div class="panel intro word-wrap">
            <div class="button-container">
                <button class="button button-grey button-small pull-left"
                        translate="cart.survey.retake.quiz" (click)="goToRetakeQuiz()"></button>
                <copy-short-url
                    *ngIf="showUrlShareables"
                    class="pull-right"
                    [buttonClass]="'btn-primary full-size-mobile'"
                    [shareOptions]="shareOptions"></copy-short-url>
            </div>
            <div class="card text-center" *ngIf="!!result">
                <h1 class="category-hero-title heading-2">{{titleText}}</h1>
                <p translate="cart.survey.intro.description"></p>
                <div class="icon-container"
                     *ngIf="!!result.surveySelectedSupplements && result.surveySelectedSupplements.length > 0">
                    <div class="icon-tile" *ngFor="let supplement of result.surveySelectedSupplements; trackBy: trackByFn">
                        <img class="icon" [src]="supplement.imageUrl" [alt]="supplement.supplementCode"/>
                        <span>{{supplement.description}}</span>
                    </div>
                </div>
            </div>
            <div class="card text-center" *ngIf="!result">
                <h1 class="category-hero-title heading-2" translate="cart.survey.not.found"></h1>
            </div>
            <img src="/image-service/ws/imgs/file/4993722/aws/w/0/h/0.img" alt="" height="104px">
        </div>
        <ng-container *ngIf="!!result && result.surveyProducts.length > 0">
            <div class="panel product-panel" *ngFor="let surveyProduct of result.surveyProducts; trackBy: trackByFn">
                <product-results-card [usanaId]="surveyProduct.usanaId" [productGroup]="surveyProduct.productGroup"
                                     [productDetails]="surveyProduct.details" (productAddedEvent)="isProductAdded=true">
                </product-results-card>
            </div>
        </ng-container>
        <div class="panel outro word-wrap" *ngIf="!!result">
            <div class="card text-center">
                <h3 class="category-hero-title heading-2" translate="cart.survey.outro.title"></h3>
                <button type="button" class="button button-primary button-large"
                        [routerLink]="CART_OVERVIEW_ROUTE"
                        [disabled]="!isProductAdded"
                        translate="cart.continue.checkout"></button>
                <button type="button" class="button button-tertiary button-large"
                        [routerLink]="[CATALOG_ROUTE, -1]"
                        translate="cart.explore.active.nutrition"></button>
            </div>
        </div>
    </div>
</section>
